import { ThemeOptions } from '@mui/material';
import { SPACING_BASE_UNIT } from 'themes/constants';
import { typography } from 'themes/components/typography';
import { generateTextFieldThemeOptions } from 'themes/components/generateTextFieldThemeOptions';
import { CobrandIdentifier } from 'features/cobrand/types';
import { generateCardThemeOptions } from 'themes/components/generateCardThemeOptions';
import { generateButtonThemeOptions } from 'themes/components/generateButtonThemeOptions';
import { generatePallet } from 'themes/generatePallet';
import { generateListThemeOptions } from './components/generateListThemeOptions';
import { generateAnimationThemeOptions } from './components/generateAnimationThemeOptions';

export const generateTheme = (cobrand: CobrandIdentifier): ThemeOptions => {
  const animationOptions = generateAnimationThemeOptions();

  return {
    palette: generatePallet(cobrand),
    typography,
    spacing: (factor: number) => factor * SPACING_BASE_UNIT, // 8px base unit
    animations: animationOptions.animations,
    components: {
      ...generateButtonThemeOptions(cobrand),
      ...generateCardThemeOptions(),
      ...generateTextFieldThemeOptions(),
      ...generateListThemeOptions(),
      ...animationOptions.components,
    },
  };
};
